module.exports = __webpack_public_path__ + "img/Metastasis-LICA_GSE236681.d1e314b8.png";